export default "__VITE_ASSET__180578ad__"